<template>
  <div id="home">
  <img :alt="Motul" class="motulLogo" src="/static/img/motul.png">
  <div style="height: 8vh; width: 100%">
    <img src="data:image/svg+xml;utf8;base64,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" style="height: 7vh; margin-top: 0.5vh; margin-left: 20vw;"/>
    Site en construction
  </div>
    <section class="search">
      <div class="search-form-container">
        <div class="mx-auto"  style="margin-top: -300px;">
          <h1 class="textRedMain">
            <!-- <span class="title">{{ $t('title') }}</span> <br > -->
            <span class="title textRedMain" style="color: white;">CARAPPLI</span> <br >
            {{ $t('baseline') }}
          </h1>
          <form @submit.prevent="submit">
            <template v-if="schema.fields.length > 0">
              <vue-form-generator
                :schema="schema"
                :model="model"
                :options="{ validationAfterLoad: true, validationAfterChanged: true }"
                :class="search-form"
              />
              <b-row>
                <b-col>
                  <b-button
                    block
                    type="submit"
                    class="mainGrad"
                  >
                    {{ $t('actions.search') }}
                  </b-button>
                </b-col>
              </b-row>
            </template>
            <div v-else class="text-center">
              <i class="ti ti-2x ti-spin ti-refresh" />
            </div>
          </form>
        </div>
      </div>
      <a
        v-scroll-to="scrollTo"
        class="go-bottom"
        href="#"
      >
        <i class="ti ti-arrow-bottom ti-3x" />
      </a>
    </section>
    <section id="explain" class="explain">
      <b-container>
        <div class="intro">
          <h2>{{ $t('pages.home.how_to.title') }}</h2>
          <p v-html="$t('pages.home.how_to.text')" />
        </div>
      </b-container>
      <image-block
        v-for="explain in explainProcess"
        :key="explain.title"
        :image-url="explain.imageUrl"
        :image-on-right="explain.imageOnRight"
        :title="explain.title"
        :text="explain.text"
      />
      <e-jumbotron :data="jumbotron">
        <b-button variant="primary" @click="openModal('sign-in-sign-up-modal', 'sign-up')">
          {{ jumbotron.btnText }}
        </b-button>
      </e-jumbotron>
    </section>
  </div>
</template>

<script>
  import VueFormGenerator from '@triotech/vue-core/src/vendor/vue-form-generator';
  import ImageBlock from '@/components/ImageBlock';
  import EJumbotron from '@/components/EJumbotron';

  export default {
    name: 'HomePage',
    components: {
      'vue-form-generator': VueFormGenerator.component,
      ImageBlock,
      EJumbotron,
    },
    data() {
      return {
        scrollTo: {
          el: '#explain',
          offset: -60,
        },
        explainProcess: [{
          imageUrl: '../../../static/img/tmp.jpg',
          imageOnRight: false,
          title: this.$t('pages.home.create.title'),
          text: this.$t('pages.home.create.text'),
        }, {
          imageUrl: '../../../static/img/home-02.jpg',
          imageOnRight: true,
          title: this.$t('pages.home.comunicate.title'),
          text: this.$t('pages.home.comunicate.text'),
        }, {
          imageUrl: '../../../static/img/home-03.jpg',
          imageOnRight: false,
          title: this.$t('pages.home.share.title'),
          text: this.$t('pages.home.share.text'),
        }],
        jumbotron: {
          bg: '../../../static/img/home-04.jpg',
          title: this.$t('pages.home.jumbotron.title'),
          btnText: this.$t('actions.start'),
        },
        search: null,
        form: null,
        model: {},
        schema: {
          fields: [],
        },
      };
    },
    async mounted() {
      await this.$ajax.get('api/public/search/_form')
        .then((data) => {
          this.$set(this.schema, 'fields', _.form(this.$t, data));
        });
    },
    methods: {
      openModal(id, data = null) {
        this.$bus.$emit(`t-event.t-modal.${id}.open`, data);
      },
      async submit() {
        if (this.model.search === undefined) {
          this.$notify({
            title: this.$t('flashes.search.empty'),
            text: this.$t('flashes.search.empty_text'),
          });
        } else {
          await this.$ajax.get(`api/public/search/?search=${this.model.search}`)
            .then((res) => {
              this.forward(res);
            });
        }
      },
      forward(result) {
        if (result.length === 0) {
          this.$notify({
            title: this.$t('flashes.search.no_result'),
            text: `${this.$t('flashes.search.no_result_for')}: ${this.model.search}`,
            type: 'warning',
          });
        } else if (result.length > 0) {
          this.$router.push({ name: 'memorial.index', params: { search: this.model.search } });
        } else {
          this.$router.push({ name: 'memorial.show', params: { id: result[0].unique_key } });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';

  /* CSS by Gabriele Marsili gabriele@trackap.com */

/*
#06beb6
#48b1bf

#159957
#155799

#4AC29A
#BDFFF3

#34e89e
#0f3443

#44A08D
#093637

#093028
#237A57

#5a3f37
#2c7744

#00bf8f
#001510

#73c8a9
#373b44
*/

  .textRedMain {
    color: white;
    /*color: #ffb35d !important;*/
  }

  .motulLogo {
    position: fixed;
    margin-left: 35vw !important;
    margin-top: -11.5vh !important;
    z-index: 100000 !important;
    height: 150px !important;
  }

  .mainGrad {
    background: #093028;
    background: -webkit-linear-gradient(to left, #093028, #237A57);
    background: -o-linear-gradient(to left, #093028, #237A57);
    background: -moz-linear-gradient(to left, #093028, #237A57);
    background: linear-gradient(to left, #093028, #237A57);
    /*border: solid white 1px*/
  }
  .mainGrad:hover {
    background: white !important;
    color: black;
    border: solid #000046 1px !important;
  }

  /* Original CSS */

  #home {
    .search {
      min-height: calc(100vh - #{$nav-height});
      margin: 0 -15px;
      position: relative;
      background: {
        image: url('../../../static/img/accueil.jpg');
        position: center;
        repeat: no-repeat;
        size: cover;
      };

      .go-bottom {
        color: $white;
        position: absolute;
        bottom: 76px;
        left: 0;
        right: 0;
        text-align: center;

        &:hover {
          text-decoration: none;
        }
      }

      .search-form-container {
        display: flex;
        align-items: center;
        flex-direction: row;
        height: calc(120vh - #{$nav-height});
        padding: 0 8rem;

        h1 {
          color: $white;

          .title {
            color: $primary;
            font-size: 3rem;
          }
        }

        /deep/ input {
          height: $input-height;
        }
      }
    }

    .explain {
      margin-top: 2rem;

      .intro {
        margin: 5rem 0;
      }
    }
  }

  @include editable-max-width(1700px) {
    .motulLogo {
        margin-left: 15vw !important;
        height: 120px !important;
        margin-left: 40vw !important;
        margin-top: -13vh !important;
      }
  }

  @include editable-max-width(600px) {
    .motulLogo {
        margin-left: 15vw !important;
        height: 120px !important;
        margin-left: 40vw !important;
        margin-top: -10vh !important;
      }
  }

  @include editable-max-width(480px) {
    .motulLogo {
        margin-left: 25vw !important;
        height: 100px !important;
        margin-left: 25vw !important;
        margin-top: -9vh !important;
      }
    }

  @include editable-max-width(575px) {
    #home {
      .search {
        .search-form-container {
          padding: 0 1rem;

          h1 {
            font-size: 1.5rem;
          }
        }
      }
    }
  }

  @include editable-max-height(620px) {
    #home {
      .search {
        .go-bottom {
          bottom: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Default/Home.vue